/**
 * [File::B_VariableText.js]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/text/B_VariableText.js
 * @목적 : 변수용 텍스트 객체로 기존 텍스트 객체와는 상이합니다.
 * @설명 :
 * @진행 : 진행 중
 * @주의 :
 * @이슈 :
 * @일자 : 2018.08.27
 * @작성 : Lee Mi Reu
 * @참조 :
 */

import MixinBuilder from '../../scripts/MixinBuilder';
import B_Real from '../base/B_Real';
import B_ChildWorld from '../base/B_ChildWorld';
import B_Define from '../../util/B_Define';

const mix = superclass => new MixinBuilder(superclass);

const init = () => {
    return class B_VariableText extends mix(B_Real).with(B_ChildWorld) {
        constructor(obj) {
            super(obj);

            if (typeof obj.container !== 'undefined') this._container = obj.container;
            if (typeof obj.CODMOS !== 'undefined') this.CODMOS = obj.CODMOS;

            obj.font = '';
            if (typeof obj.align === 'undefined') obj.align = 'left';
            if (typeof obj.lineHeight === 'undefined') obj.lineHeight = 0;

            this._suffix = obj.suffix || '';
            this._value = obj.value || '';

            obj.text += this._suffix;

            this._strResType = B_Define.ARR_RES_TYPE[4];

            this._object = new createjs
                .Text(
                    obj.text,
                    `bold ${obj.size}px 'Yanolja', sans-serif`,
                    'black'
                );
            this._object.textAlign = obj.align;
            this._object.lineHeight = 18;

            // 배경 기능 추가
            if (obj.background === true) {
                if (typeof obj.backgroundColor !== 'undefined') this._backgroundColor = obj.backgroundColor;
                this._rectangle = new createjs.Shape();
                this.backgroundUpdate();
                this._container.addChildAt(this._rectangle, 0);
            }
        }

        /**
         * [ Function :: backgroundUpdate ]
         *
         * @DES :: 텍스트가 변경 될 때 배경의 크기도 재지정 + 체력바 형식 테스트
         * @IP1 :: null
         * @O.P :: null
         */
        backgroundUpdate () {
            const BOUND = this._object.getBounds();
            this._rectangle.graphics.clear().beginFill(this._backgroundColor || '#73cdff')
                .drawRoundRect(this._object.x, this._object.y, BOUND.width, BOUND.height, 5);

            // const VALUE = this._value;
            // this._rectangle.graphics.clear().beginFill(this._backgroundColor || "#73cdff")
            // .drawRect(this._object.x, this._object.y, BOUND.width / 100 * (VALUE > 100 ? 100 : VALUE < 0 ? 0 : VALUE), BOUND.height);
        }

        /**
         * [ Function :: set value ]
         *
         * @DES ::
         * @IP1 :: value
         * @O.P :: null
         */
        set value (value) {
            this._value = value;
            this.text = this._value;
        }

        /**
         * [ Function :: set text ]
         *
         * @DES :: 텍스트를 실시간으로 변경하기 위한 함수
         * @IP1 :: text
         * @O.P :: null
         */
        set text (text) {
            this._object.text = ` ${text}${this._suffix || ''} `;
            if (typeof this._rectangle !== 'undefined') this.backgroundUpdate();
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/text/B_VariableText2.js